module.exports = __webpack_public_path__ + "static/media/goods-services.32f43837.svg";